@if(mustShow) {
<header>
  <div class="left-section">
    <p>{{ currentTime | datetimeFormat:'time':currentLanguage }}</p>
  </div>
  <div class="center-section">
    <p>{{ currentDate | datetimeFormat:'date':currentLanguage }}</p>
  </div>
  <div class="right-section">
    <img src="../../../assets/logo/logo_vinci.svg" alt="Logo VINCI" />
  </div>
</header>
}